import { Button } from '@mui/material';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import { PATH_NAME } from '../../../../../configs/pathName';
import { PostContext } from '../../../../../context/PostContext';
import { QuickLoginModalHOC } from '../../../../modal/LoginModal2HOC';
import { OutlinedDocumentUploadIcon } from '../../../svgIcon/outlined';

const PostRecruitmentUploadModal = dynamic(() => import('../recruitment'));

const UploadApplicationsButton = () => {
  const { isLocked, isRecruitExpired, isRecruitStarted, postId } =
    useContext(PostContext);
  const router = useRouter();

  const { openModal } = router.query;

  const enableSubmitCV = !isRecruitExpired && isRecruitStarted && !isLocked;

  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((p) => !p);

  useEffect(() => {
    if (openModal === 'true') {
      setOpen(true);
    }
  }, [openModal]);

  return (
    <>
      <QuickLoginModalHOC
        handleClickWhenDisabledQuickLogin={enableSubmitCV ? toggle : undefined}
        loginSuccessCb={() => {
          router.push({
            pathname: PATH_NAME.HOME_FEED_POST_DETAIL,
            query: {
              pid: postId,
              openModal: true,
            },
          });
        }}
      >
        <Button
          disabled={!enableSubmitCV}
          variant="high_emphasis_v2"
          fullWidth
          className="!gap-2"
        >
          <OutlinedDocumentUploadIcon />
          Tải lên
        </Button>
      </QuickLoginModalHOC>
      {open && (
        <PostRecruitmentUploadModal
          open={open}
          toggle={toggle}
          postId={postId}
        />
      )}
    </>
  );
};

export default UploadApplicationsButton;
